if (!customElements.get('page-rewards')) {
  customElements.define(
    'page-rewards',
    class PageRewards extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.els.trigger.element.addEventListener('click', this.onClick)
      }

      onClick () {
        window.scrollTo({
          top:
            window.BAO.utils.getOffsetTop(
              window.BAO.utils.getElement(
                `[data-external-el="page-rewards.target"]`,
              ),
            ) - 175,
          left: 0,
          behavior: 'smooth',
        })
      }
    },
  )
}
